import { animate, AnimationOptions, Driver } from "popmotion";
import { Bounds } from "../space/bounds";
import { RDisplay } from "../../ui/RotDisplay";

export function awaitAnimate<V>(options: AnimationOptions<V>) {
  return new Promise<void>((r) => {
    animate({ onComplete: r, ...options });
  });
}

const FINISHED = new Promise<void>((r) => r());

export class Animatable {
  status: Promise<void> = FINISHED;
  updatable: (elapsed: number) => void = () => null;
  driver: Driver = (updateFn: any) => {
    return {
      start: () => (this.updatable = updateFn),
      stop: () => (this.updatable = () => null),
    };
  };

  update(elapsed: number) {
    this.updatable(elapsed);
  }
}

export enum ParticleModes {
  DRAW,
  DRAW_OVER,
  DRAW_APPEND,
  DRAW_OVER_FIRST,
  DRAW_OVER_LAST,
}

export class Particle<T> extends Animatable {
  mode: ParticleModes;
  char: string | null;
  fg: string | null;
  bg: string | null;
  _end?: () => void;
  constructor(
    breed: ParticleBreed<T>,
    public id: number,
    public x: number,
    public y: number,
    public options?: T
  ) {
    super();
    this.mode = breed.mode;
    this.char = breed.char;
    this.fg = breed.fg;
    this.bg = breed.bg;

    const endSwitch = new Promise<void>((r) => (this._end = r));
    this.status = Promise.race([breed.animate(this), endSwitch]);
  }

  finish() {
    this._end && this._end();
  }

  render(display: RDisplay, bounds: Bounds, view: Bounds) {
    //TODO: Switch on Draw ModeParticle
    let drawFn: keyof RDisplay;
    let ch = this.char;
    switch (this.mode) {
      case ParticleModes.DRAW:
        drawFn = "draw";
        break;
      case ParticleModes.DRAW_OVER:
        drawFn = "drawOver";
        break;
      case ParticleModes.DRAW_APPEND:
        drawFn = "drawAppend";
        ch = ch || "";
        break;
      case ParticleModes.DRAW_OVER_FIRST:
        drawFn = "drawOverFirst";
        break;
      case ParticleModes.DRAW_OVER_LAST:
        drawFn = "drawOverLast";
        break;
    }

    display[drawFn](
      this.x + bounds.x - view.x,
      this.y + bounds.y - view.y,
      ch,
      this.fg,
      this.bg
    );
  }
}

export type ParticleBreed<T> = {
  mode: ParticleModes;
  char: string | null;
  fg: string | null;
  bg: string | null;
  animate: (particle: Particle<T>) => Promise<void>;
};
